import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useT } from "../i18n";
import { findTopic, wingChunTopics } from "../data/wingchunTopics";

const WingChunTopic = () => {
  const { slug } = useParams();
  const { lang } = useLanguage();
  const t = useT(lang);
  const topic = findTopic(slug);

  if (!topic) return <Navigate to="/wing-chun" replace />;

  const sections = lang === "el" ? topic.sections_el : topic.sections_en;
  const otherTopics = wingChunTopics.filter((tp) => tp.slug !== topic.slug).slice(0, 3);

  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden py-24 md:py-32">
        <div className="absolute inset-0">
          <img src={topic.cover} alt="" className="w-full h-full object-cover img-moody" />
          <div className="absolute inset-0 bg-[#0A0A0A]/80" />
        </div>
        <div className="container-wc relative z-10 max-w-4xl fade-up">
          <Link to="/wing-chun" data-testid="topic-back" className="eyebrow hover:text-white transition-colors">
            ← Wing Chun
          </Link>
          <h1 className="h-display text-5xl md:text-6xl mt-4 mb-6">
            {lang === "el" ? topic.label_el : topic.label_en}
          </h1>
          <p className="text-dim text-lg max-w-3xl leading-relaxed">
            {lang === "el" ? topic.intro_el : topic.intro_en}
          </p>
        </div>
      </section>

      {/* SECTIONS */}
      <section className="py-20">
        <div className="container-wc max-w-4xl space-y-10">
          {sections.map((s, i) => (
            <div key={s.h} data-testid={`section-${i}`} className="border-l-2 border-gold pl-6">
              <span className="eyebrow">0{i + 1}</span>
              <h2 className="font-serif text-3xl md:text-4xl mt-2 mb-4">{s.h}</h2>
              <p className="text-[#E8E8E0] text-lg leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>

      {/* OTHER TOPICS */}
      <section className="py-16 bg-surface border-t border-goldSoft">
        <div className="container-wc">
          <h3 className="eyebrow mb-6">{lang === "el" ? "Συνεχίστε την ανάγνωση" : "Continue reading"}</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {otherTopics.map((tp) => (
              <Link key={tp.slug} to={`/wing-chun/${tp.slug}`} className="card group block">
                <h4 className="font-serif text-xl group-hover:text-gold transition-colors">
                  {lang === "el" ? tp.label_el : tp.label_en}
                </h4>
                <span className="inline-flex items-center gap-2 text-gold text-xs uppercase tracking-widest mt-3">
                  {lang === "el" ? "Διαβάστε" : "Read"} <ArrowRight size={12} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 text-center container-wc">
        <Link to="/contact" data-testid="topic-cta" className="btn-primary">
          {t.hero.cta_primary} <ArrowRight size={16} />
        </Link>
      </section>
    </div>
  );
};

export default WingChunTopic;
